<template>
  <div class="contact-address">
    <AmList class="address__list">
      <AmListItem>
        <template #title>
          <AmTypography
            :text="$t('purchaseUserData.contact')"
            contact
            typography-style="l5"
            weight="bold"
          />
        </template>
        <template #subtitle>
          {{ email }} <br />
          {{ telephone | VMask('(##) # ####-####') }}
        </template>
        <template #prepend>
          <div
            v-show="showEdit"
            class="edit"
            @click="editContact()"
          >
            <AmIconMaterial
              name="edit"
              size="sm"
              :class="`edit__icon text--${theme.color}`"
            />
            <AmTypography
              :class="`text--${theme.color}`"
              :text="$t('edit')"
              typography-style="l5"
            />
          </div>
        </template>
      </AmListItem>
      <hr class="address__list__divider" />
      <AmListItem>
        <template #title>
          <AmTypography
            :text="$t('purchaseUserData.deliveryAddress')"
            typography-style="l5"
            weight="bold"
          />
        </template>
        <template #subtitle>
          {{ street }}, {{ number }} <br />
          {{ city }}, {{ state }} {{ postcode }}
        </template>
        <template #prepend>
          <div
            v-show="showEdit"
            class="edit"
            @click="editAdress()"
          >
            <AmIconMaterial
              name="edit"
              size="sm"
              :class="`edit__icon text--${theme.color}`"
            />
            <AmTypography
              :class="`text--${theme.color}`"
              :text="$t('edit')"
              typography-style="l5"
            />
          </div>
        </template>
      </AmListItem>
    </AmList>
  </div>
</template>

<script>
import themeMixin from '@/components/mixins/themeMixin'
import { mapGetters, mapState } from 'vuex'
import AmList from '@/components/molecules/AmList.vue'
import AmListItem from '@/components/atoms/AmListItem.vue'

export default {
  name: 'ContactAddress',
  components: {
    AmList,
    AmListItem,
  },
  mixins: [themeMixin],
  props: {
    showEdit: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    ...mapState('Checkout', {
      contactAdress: (state) => state.stepsData,
    }),
    ...mapGetters('Customer', {
      email: 'getEmail',
      telephone: 'getTelephone',
      street: 'getAddressStreet',
      number: 'getAddressStreetNumber',
      city: 'getAddressCity',
      state: 'getAddressState',
      postcode: 'getPostcode',
    }),
  },
  methods: {
    editAdress() {
      this.$emit('editAdress')
    },
    editContact() {
      this.$emit('editContact')
    },
  },
}
</script>

<style lang="scss" scoped>
.contact-address {
  .address__list {
    background: $white;
    ::v-deep {
      .am-list-item {
        background: $white !important;
      }
    }

    &__divider {
      margin: 0;
    }

    .edit {
      display: flex;
      justify-content: center;
      .edit__icon {
        margin-right: 8px;
      }
    }
  }
}
</style>
